import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../Reducer/rootReducer';
import rootSaga from '../Saga/rootSaga';

const configureStore = (preloadedState) => {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [sagaMiddleware];

  const store = createStore(rootReducer, preloadedState, applyMiddleware(...middlewares));
  sagaMiddleware.run(rootSaga)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../Reducer/rootReducer', () => {
      const nextRootReducer = require('../Reducer/rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;
